import {
  StrategicTerritoriesWidgetKey,
  type StrategicTerritoriesWidgetSchemaType,
} from '@inference.engine/widgets/web';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';

/**
 * Factory that binds the StrategicTerritories widget processor to the
 * supplied dep surface. Returns the processor list consumed by the central
 * widget dispatcher in `features/widgets/processors/`.
 *
 * Per architecture decision β (#1760) + C4 (#1605) + discovery #53: the
 * widget slice MUST NOT value-import `widgetProcessorDeps` from
 * `@/features/widgets/processors/...` (that would be a cross-feature OUT).
 * The dispatcher (which owns the deps binding) calls this factory and
 * supplies the deps.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<StrategicTerritoriesWidgetSchemaType>> = {
    key: StrategicTerritoriesWidgetKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<StrategicTerritoriesWidgetSchemaType>
    >['processor'],
  };
  return [create];
};
